module.exports = __webpack_public_path__ + "static/media/BOTON WEB_Produccion Musical.a04fc430.png";